import { cn } from '@playbooks/ui/lib/utils'
import { ReactNode } from 'react'

export default function ElementWrapper({
  component,
  locked,
  id,
}: {
  id: number | undefined
  component: ReactNode
  locked?: boolean
}) {
  return (
    <div id={id ? `section-element-${id}` : undefined} className={cn(locked && 'pointer-events-none')}>
      {component}
    </div>
  )
}
